import React, { Fragment, useLayoutEffect, useRef, useState } from 'react';
import { Row } from 'react-bootstrap';

import Content from 'components/common-sfims/Content';
import Setting from 'components/pages/standard/code/Setting';
import Table from 'components/pages/standard/code/Table';
import { getLoginInform } from 'function/login';
import useObjReducer from 'hooks/useObjReducer';
import { RETURN_YN } from 'types/type';

/**
 * 기준 정보 > 속성 코드 관리 - 목록
 */
const List = () => {
  /* variable */
  const { haccpYn } = getLoginInform();

  /* reference */
  const scrollEl = useRef(null);

  /* state */
  // 로드할 차수
  const [loadOrder, setLoadOrder] = useState(0);
  // 선택한 정보 목록
  const [selects, setSelects] = useState([]);
  // 설정 모달에 전달할 데이터
  const [settingModalProps, setSettingModalProps] = useObjReducer({});

  /* watch */
  useLayoutEffect(() => {
    // 2차 코드 이상 선택 시 가장 우측으로 스크롤
    if (selects.length >= 3) {
      scrollEl.current.scrollTo(
        scrollEl.current.children[0].offsetWidth * (selects.length + 1),
        0
      );
    }
  }, [selects]);

  /* event */
  // 선택 시
  const onSelect = (inform = {}, order) => {
    // 다음 차수 로드
    setLoadOrder(order + 1);

    // 다음 차수까지만 표시
    setSelects(prevState => {
      const selects = prevState.filter((value, index) => index <= order);

      selects[order] = inform;

      return selects;
    });
  };
  // 등록/수정 클릭 시
  const onSettingClick = (inform = {}, order) => {
    // 설정 모달 표시
    setSettingModalProps({
      show: true,
      inform,
      order
    });
  };
  // 휠 이동 시
  const onWheel = ({ nativeEvent: { wheelDelta } }) => {
    // 가로로 스크롤
    scrollEl.current.scrollTo(wheelDelta * -1 + scrollEl.current.scrollLeft, 0);
  };

  /* view */
  return (
    <>
      <Content>
        {haccpYn === RETURN_YN.Y && (
          <Fragment key="title">기준 정보 &gt; 속성 코드 관리</Fragment>
        )}
        <Fragment key="body">
          <Row
            ref={scrollEl}
            className="flex-nowrap table-responsive"
            onWheel={onWheel}
          >
            <Table
              parent={haccpYn === RETURN_YN.Y ? 'sfsh' : 'sfims'}
              onSelect={inform => onSelect(inform, 0)}
              onSettingClick={onSettingClick}
            />
            {selects.map((value = {}, index) => (
              <Table
                key={`selects${value.seq}`}
                load={loadOrder === index + 1}
                order={index + 1}
                parent={value.codeCd}
                onLoad={() => setLoadOrder(0)}
                onSelect={inform => onSelect(inform, index + 1)}
                onSettingClick={onSettingClick}
              />
            ))}
          </Row>
        </Fragment>
      </Content>
      <Setting
        {...settingModalProps}
        onHide={() => setSettingModalProps({ show: false })}
        onSetting={() => setLoadOrder(settingModalProps.order)}
      />
    </>
  );
};

export default List;
